import TypeAheadInput from "./TypeAheadInput";

export default TypeAheadInput;